export function RoadmapPage() {
  return (
    <section className="page" id="roadmap" data-testid="dp-page-roadmap">
      <div className="wrap">
        <div className="head">
          <div className="eyebrow">Roadmap</div>
          <h2>We will earn expansion through real workflow use.</h2>
          <p>
            We do not publish speculative calendar promises. Our sequence is to prove the governed
            workflow, expand with evidence, then add broader portfolio controls.
          </p>
        </div>
        <div className="road">
          <article className="phase now">
            <div className="label">Now</div>
            <h3>Design-partner discovery</h3>
            <p>Learn from real project and operations leaders before product sessions begin.</p>
            <ul>
              <li>Discovery conversations</li>
              <li>Validate buyer pain and current workflow</li>
              <li>Select pilot use case and template</li>
            </ul>
          </article>
          <article className="phase">
            <div className="label">Next</div>
            <h3>Moderated pilot workflow</h3>
            <p>Validate one reliable governed project flow with selected partners.</p>
            <ul>
              <li>Ownership and project template</li>
              <li>Risk, evidence, and approval checkpoints</li>
              <li>Decision-ready project visibility</li>
            </ul>
          </article>
          <article className="phase">
            <div className="label">Later</div>
            <h3>Portfolio control</h3>
            <p>Expand only where repeated design-partner evidence supports it.</p>
            <ul>
              <li>Cross-project dependencies</li>
              <li>Portfolio views and prioritization</li>
              <li>Capacity and financial controls</li>
            </ul>
          </article>
        </div>
      </div>
    </section>
  );
}
